import { Outlet } from '@remix-run/react';

import { AuthCheckLayout } from 'platform/components/AuthenticationCheck';

import { RouteComponentOutput } from 'shared/helpers/routes';

export default function AuthLayout(): RouteComponentOutput {
  return (
    <AuthCheckLayout>
      <Outlet />
    </AuthCheckLayout>
  );
}
